import { Observable } from 'rxjs/Observable'
import { combineEpics } from 'redux-observable'

import app from 'containers/app'
import { api } from './api'
import * as actions from './actions'
import { fetchBannedIPsSuccess } from './selectors'

const fetchBannedIPsEpic = (action$, { getState }) =>
  action$
    .ofType(actions.fetchBannedIPs.toString())
    .pluck('payload')
    .filter(() => !fetchBannedIPsSuccess(getState()))
    .mergeMap(() => {
      return api
        .fetchBannedIPs()
        .map(response => actions.fetchBannedIPsSuccess(response.bannedIps))
        .startWith(() => actions.fetchBannedIPsPending())
        .catch(error => Observable.of(actions.fetchBannedIPsFailed(error)))
    })

function banIPEpic(action$) {
  return action$
    .ofType(actions.banIP.toString())
    .map(action => action.payload)
    .mergeMap(({ ip, conversationId }) =>
      api
        .banIP(ip, conversationId)
        .map(response => {
          app.actions.NotificationActions.pushNotification({
            content: 'This user has been blocked, they can no longer see Drift.',
            variant: 'green',
          })
          return actions.banIPSuccess(response.response.bannedIps)
        })
        .startWith(() => actions.banIPPending({ ip }))
        .catch(error => {
          app.actions.NotificationActions.pushNotification({
            content: 'We were unable to block this user. Please try again.',
            variant: 'red',
            sticky: true,
          })
          return Observable.of(actions.banIPFailed({ ip, error }))
        })
    )
}

function unbanIPEpic(action$) {
  return action$
    .ofType(actions.unbanIP.toString())
    .map(action => action.payload)
    .mergeMap(({ ip, conversationId }) =>
      api
        .unbanIP(ip, conversationId)
        .map(response => {
          app.actions.NotificationActions.pushNotification({
            content: 'This user has been unblocked, they can now see Drift.',
            variant: 'green',
          })
          return actions.unbanIPSuccess(response.response.bannedIps)
        })
        .startWith(() => actions.unbanIPPending({ ip }))
        .catch(error => {
          app.actions.NotificationActions.pushNotification({
            content: 'We were unable to unblock this user. Please try again.',
            variant: 'red',
            sticky: true,
          })
          return Observable.of(actions.unbanIPFailed({ ip, error }))
        })
    )
}

export const epic = combineEpics(fetchBannedIPsEpic, banIPEpic, unbanIPEpic)



// WEBPACK FOOTER //
// ./src/scripts/app/modules/ban/epic.js